"use client";

import Link from "next/link";

import {
  usePrivy
} from "@privy-io/react-auth";

export default function SiteHeader() {
  const {
    authenticated,
    logout
  } = usePrivy();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex h-20 items-center justify-between">
          <Link
            href="/"
            className="text-xl font-bold tracking-wide text-white"
          >
            AGPSIRA
          </Link>

          <nav className="hidden items-center gap-8 text-slate-300 lg:flex">
            <Link href="/who-we-serve" className="transition-colors hover:text-white">
              Who We Serve
            </Link>
            <Link href="/what-we-do" className="transition-colors hover:text-white">
              What We Do
            </Link>
            <Link href="/find-your-path" className="transition-colors hover:text-white">
              Find Your Path
            </Link>
            <Link href="/why-agpsira" className="transition-colors hover:text-white">
              Why AGPSIRA
            </Link>
            <Link href="/account" className="transition-colors hover:text-white">
              Account
            </Link>
            <Link href="/dashboard" className="transition-colors hover:text-white">
              Dashboard
            </Link>
            <Link href="/admin/dashboard" className="transition-colors hover:text-white">
              Admin
            </Link>
          </nav>

          {authenticated ? (
            <button
              type="button"
              onClick={() => void logout()}
              className="rounded-xl border border-slate-700 px-4 py-2 font-semibold text-white transition-colors hover:border-slate-500"
            >
              Sign out
            </button>
          ) : (
            <Link
            href="/login"
            className="rounded-xl bg-blue-600 px-4 py-2 font-semibold text-white transition-colors hover:bg-blue-700"
          >
            Sign in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}